import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";

const LOGO = "https://customer-assets.emergentagent.com/job_brigadeiro-shop-10/artifacts/ro8wmkw2_Logo%20Confeitaria%20Divertido%20Rosa%20e%20Bege.png";

export default function AdminLoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const handle = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao iniciar sessão");
    } finally {
      setSubmitting(false);
    }
  };

  const input = "w-full bg-cream-alt border border-cocoa/15 rounded-xl px-4 py-3 text-cocoa-dark placeholder:text-cocoa-soft/60 focus:outline-none focus:ring-2 focus:ring-rose focus:border-rose transition";

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 bg-cream-deep">
      <form onSubmit={handle} className="w-full max-w-md bg-cream rounded-3xl shadow-xl p-10 border border-cocoa/10">
        <div className="text-center mb-8">
          <img src={LOGO} alt="Caseirinhos" className="w-20 h-20 rounded-full mx-auto" />
          <p className="text-xs uppercase tracking-widest text-rose-accent mt-5">Área restrita</p>
          <h1 className="font-heading text-4xl text-cocoa-dark mt-2">Painel Caseirinhos</h1>
        </div>
        <div className="space-y-4">
          <input data-testid="admin-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={input} />
          <input data-testid="admin-password" type="password" placeholder="Palavra-passe" value={password} onChange={(e) => setPassword(e.target.value)} className={input} />
        </div>
        <button data-testid="admin-login-submit" disabled={submitting} className="w-full mt-6 bg-cocoa-dark hover:bg-cocoa text-cream py-3.5 rounded-full font-medium transition-colors disabled:opacity-60">
          {submitting ? "A entrar..." : "Entrar"}
        </button>
        <p className="text-xs text-cocoa-soft mt-6 flex items-center justify-center gap-1.5">
          <Lock className="w-3 h-3" /> Apenas administradores autorizados
        </p>
      </form>
    </div>
  );
}
